"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Context = _interopRequireDefault(require("./Context"));

var SayPrimitive =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(SayPrimitive, _React$Component);

  function SayPrimitive(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, SayPrimitive);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(SayPrimitive).call(this, props));
    _this.handleBoundary = _this.handleBoundary.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleEnd = _this.handleEnd.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleError = _this.handleError.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleStart = _this.handleStart.bind((0, _assertThisInitialized2["default"])(_this));
    _this.state = {
      id: Date.now() + Math.random()
    };
    return _this;
  }

  (0, _createClass2["default"])(SayPrimitive, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // TODO: Should dequeue self on unmount
      this.unmounted = true;
      this.props.context.cancel(this.state.id)["catch"](function (err) {
        return 0;
      });
    }
  }, {
    key: "handleBoundary",
    value: function handleBoundary(event) {
      !this.unmounted && this.props.onBoundary && this.props.onBoundary(event);
    }
  }, {
    key: "handleEnd",
    value: function handleEnd(event) {
      !this.unmounted && this.props.onEnd && this.props.onEnd(event);
    }
  }, {
    key: "handleError",
    value: function handleError(event) {
      !this.unmounted && this.props.onError && this.props.onError(event);
    }
  }, {
    key: "handleStart",
    value: function handleStart(event) {
      !this.unmounted && this.props.onStart && this.props.onStart(event);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.speak !== this.props.speak;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee() {
        var _this2$props, context, lang, pitch, rate, text, voice, volume, id;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2$props = _this2.props, context = _this2$props.context, lang = _this2$props.lang, pitch = _this2$props.pitch, rate = _this2$props.rate, text = _this2$props.speak, voice = _this2$props.voice, volume = _this2$props.volume;
                id = _this2.state.id;
                context.speak({
                  id: id,
                  lang: lang,
                  onBoundary: _this2.handleBoundary,
                  onEnd: _this2.handleEnd,
                  onError: _this2.handleError,
                  onStart: _this2.handleStart,
                  pitch: pitch,
                  rate: rate,
                  text: text,
                  voice: voice,
                  volume: volume
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))()["catch"](function (err) {
        return console.error(err);
      });
      return false;
    }
  }]);
  return SayPrimitive;
}(_react["default"].Component);

var SayPrimitiveWithContext = function SayPrimitiveWithContext(props) {
  return _react["default"].createElement(_Context["default"].Consumer, null, function (context) {
    return _react["default"].createElement(SayPrimitive, (0, _extends2["default"])({
      context: context
    }, props), props.children);
  });
};

SayPrimitiveWithContext.propTypes = {
  lang: _propTypes["default"].string,
  pitch: _propTypes["default"].number,
  rate: _propTypes["default"].number,
  onBoundary: _propTypes["default"].func,
  onEnd: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  onStart: _propTypes["default"].func,
  speak: _propTypes["default"].string,
  voice: _propTypes["default"].oneOfType([_propTypes["default"].any, _propTypes["default"].func]),
  volume: _propTypes["default"].number
};
var _default = SayPrimitiveWithContext;
exports["default"] = _default;